
export const programs = [
  {
    id: 1,
    title: 'FOOTBALL',
    subtitle: 'Grades K-5',
    description: 'Learn fundamentals, teamwork, and sportsmanship in a safe, supportive environment. Our experienced coaches focus on skill development and character building.',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/16dde075b9bffe943c9ba559d8eb943d.jpeg',
    icon: 'ri-star-line',
    gradeLevels: ['K1', '2nd', '3rd', '4th', '5th'],
    headCoach: 'To Be Determined',
    link: '/programs/football'
  },
  {
    id: 2,
    title: 'CHEER',
    subtitle: 'Grades K-5',
    description: 'Build confidence, coordination, and team spirit through cheerleading. Our program teaches stunts, jumps, cheers, and dance in a positive, encouraging atmosphere.',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/0c5d664a89f7320ecd6d7c6ad5c8ed5a.jpeg',
    icon: 'ri-star-line',
    gradeLevels: ['K1', '2nd', '3rd', '4th', '5th'],
    headCoach: 'To Be Determined',
    link: '/programs/cheer'
  }
];